<div rtBlock="results">
    @if (result(); as calcResult) {
        <!-- HERO: the angle as the one big figure, the rise and the going under it -->
        <div rtElem="hero" qa-dataid="results-hero">
            <div rtElem="hero-label" i18n="@@resultAngle">Угол наклона</div>
            <div rtElem="hero-value">{{ calcResult.stairAngle | number: '1.1-1' }}°</div>
            <div rtElem="hero-sub" qa-dataid="results-hero-sub">
                <span i18n="@@resultsHeroRise">Подъём</span>
                {{ calcResult.riserHeight | number: '1.0-0' }}
                <span i18n="@@unitMm">мм</span>
                ·
                <span i18n="@@resultsHeroTread">проступь</span>
                {{ calcResult.treadDepth | number: '1.0-0' }}
                <span i18n="@@unitMm">мм</span>
            </div>
        </div>

        <!-- TILES: four figures two by two -->
        <div rtElem="tiles">
            <div rtBlock="tile" qa-dataid="results-tile">
                <span rtElem="label" i18n="@@resultTileSteps">Ступеней</span>
                <span rtElem="value">{{ calcResult.stepCount }}</span>
            </div>
            <div rtBlock="tile" qa-dataid="results-tile">
                <span rtElem="label" i18n="@@resultTotalRun">Длина по полу</span>
                <span rtElem="value">
                    {{ calcResult.totalRun | number: '1.0-0' }}
                    <ng-container i18n="@@unitMm">мм</ng-container>
                </span>
            </div>
            <div rtBlock="tile" qa-dataid="results-tile">
                <span rtElem="label" i18n="@@resultWoodVolume">Объём дерева</span>
                <span rtElem="value">
                    {{ calcResult.woodVolumeM3 | number: '1.2-2' }}
                    <ng-container i18n="@@unitM3">м³</ng-container>
                </span>
            </div>
            <div rtBlock="tile" qa-dataid="results-tile">
                <span rtElem="label" i18n="@@resultTileWeight">Вес</span>
                <span rtElem="value">
                    ≈ {{ calcResult.estimatedWeightKg | number: '1.0-0' }}
                    <ng-container i18n="@@unitKg">кг</ng-container>
                </span>
            </div>
        </div>

        <!-- PRICE: hidden by SHOW_MATERIAL_COST, kept for when the owner turns it back on -->
        @if (showCost) {
            <div rtElem="price">
                <div rtElem="price-label">
                    <span i18n="@@resultCost">Стоимость материала (ориент.)</span>
                </div>
                <div rtElem="price-value">
                    {{ calcResult.estimatedCostUsd | number: '1.0-0' }}
                    <small i18n="@@unitUsd">$</small>
                </div>
            </div>
        }

        <!-- NORMS: one row per checked norm with a text mark, headroom with its value -->
        @if (normRows().length) {
            <section rtBlock="norms">
                <h3 rtElem="title" i18n="@@sectionValidation">Проверка норм</h3>
                @for (normRow of normRows(); track normRow.code) {
                    <div rtElem="row" qa-dataid="results-norm-row" [attr.data-code]="normRow.code">
                        <span rtElem="label">{{ normRow.label }}</span>
                        <span
                            rtElem="tag"
                            qa-dataid="results-norm-tag"
                            [rtMod]="{
                                ok: normRow.severity === 'ok',
                                warning: normRow.severity === 'warning',
                                error: normRow.severity === 'error',
                            }">
                            @if (normRow.value; as normValue) {
                                <span rtElem="mark-hidden">{{ normRow.mark }}:</span>
                                {{ normValue }}
                            } @else {
                                {{ normRow.mark }}
                            }
                        </span>
                    </div>
                }
            </section>
        }

        <!-- WARNING BOX: the message of the first failed or borderline check -->
        @if (normNotice(); as notice) {
            <div rtElem="notice" qa-dataid="results-norm-notice" [rtMod]="{ error: notice.severity === 'error' }">
                <svg
                    rtElem="notice-icon"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    aria-hidden="true">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="7" x2="12" y2="13" />
                    <line x1="12" y1="17" x2="12" y2="17" />
                </svg>
                <span>{{ notice.message }}</span>
            </div>
        }
    }

    <!-- ACTIONS: SAVE / LOAD -->
    <section rtBlock="actions">
        <button rtElem="btn" rtButton type="button" qa-dataid="results-export" [rtMod]="{ save: true }" (click)="exportRequested.emit()">
            <span i18n="@@btnExportConfig">Сохранить</span>
            <span rtElem="arr" aria-hidden="true">↓</span>
        </button>
        <button rtElem="btn" rtButton type="button" qa-dataid="results-export-dxf" [disabled]="!result()" (click)="dxfRequested.emit()">
            <span i18n="@@btnExportDxf">DXF для CAD</span>
            <span rtElem="arr" aria-hidden="true">↓</span>
        </button>
        <button rtElem="btn" rtButton type="button" qa-dataid="results-export-parts" [disabled]="!result()" (click)="partsRequested.emit()">
            <span i18n="@@btnExportParts">DXF по деталям</span>
            <span rtElem="arr" aria-hidden="true">↓</span>
        </button>
        <button rtElem="btn" rtButton type="button" (click)="fileInput.click()">
            <span i18n="@@btnImportConfig">Загрузить .json</span>
            <span rtElem="arr" aria-hidden="true">↑</span>
        </button>
        <button rtElem="btn" rtButton type="button" [disabled]="justCopied()" (click)="shareRequested.emit()">
            <span i18n="@@btnShareConfig">Поделиться</span>
            <span rtElem="arr" aria-hidden="true">
                @if (justCopied()) {
                    <svg
                        viewBox="0 0 24 24"
                        width="14"
                        height="14"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.4"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                } @else {
                    <svg
                        viewBox="0 0 24 24"
                        width="14"
                        height="14"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                }
            </span>
        </button>
        <!-- native-ok: the kit file input draws its own outlined button with an icon and a file card list, while the site keeps its load button above and reads the file at once (owner decision: keep the site look) -->
        <input #fileInput type="file" accept=".json" hidden (change)="onFileSelected($event)" />
        <div
            rtElem="dropzone"
            qa-dataid="results-dropzone"
            [rtMod]="{ active: dropActive() }"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave()"
            (drop)="onDrop($event)">
            <span i18n="@@dropzoneHint">или перетащите .json</span>
        </div>
    </section>

    <!-- FEEDBACK FORM -->
    <footer rtBlock="feedback">
        <h3 rtElem="title" i18n="@@sectionFeedback">Обратная связь</h3>
        <sc-feedback-form
            [contextData]="config()"
            (feedbackOpened)="feedbackOpened.emit()"
            (feedbackSubmitted)="feedbackSubmitted.emit()"
            (feedbackFailed)="feedbackFailed.emit($event)" />
        <a rtElem="privacy-link" routerLink="/privacy" i18n="@@footerPrivacyLink">Политика конфиденциальности</a>
    </footer>
</div>
